import React from 'react';
import ReactPlayer from 'react-player';

const Scenario3Video3 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/llDmrzynD68' controls={true} />
        </div>
    );
}

export default Scenario3Video3;